import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import messages from './messages'
import { Modal, Button, TextArea, Banner } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ order }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const modal = useModal()

  const onSubmit = () => {
    setLoading(true)

    const body = new FormData()
    body.append('orderId', order.uid)
    body.append('customernote', message)

    fetch(`/ordertask/setCustomerNoteForAll.json`, { method: 'POST', body })
      .then(() => {
        toastr.success(formatMessage(messages.success))
        setLoading(false)
        modal.resolve()
        modal.remove()
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => loading ? undefined : onSubmit()}
      title={formatMessage(messages.title)}
    >
      <div className='space-y-4'>
        <Banner state="warning" title={formatMessage(messages.warning)} />
        <TextArea
          label={formatMessage(messages.textAreaLabel)}
          rows={4}
          value={message}
          onChange={({ target: { value } }) => setMessage(value)}
        />
        <Button
          disabled={loading}
          onClick={onSubmit}
        >
          { loading ? formatMessage(messages.delivering) : formatMessage(messages.deliver) }
        </Button>
      </div>
    </Modal>
  )
})
